<template>
    <div class="mt-n16">
        <v-main class="d-flex d-md-none">
            <v-row class="mb-0">
                <v-col cols="6">
                    <h2 class="my4"><v-icon>mdi-cards-playing-outline</v-icon>주문 내역</h2>
                </v-col>
                <v-col cols="6">
                    <v-btn icon outlined class="mr-3 mt-n1 d-none d-md-flex" style="float:right" @click="getOrders">
                        <v-icon>mdi-card-search</v-icon>
                    </v-btn>
                    <v-text-field
                            label="검색어를 입력하세요"
                            outlined
                            dense
                            clearable
                            v-model="orderSearchText"
                            @keydown.enter="getOrders"
                            class="mr-3 mt-n1 d-none d-sm-block"
                            style="float:right;"
                    ></v-text-field>
                    <v-checkbox
                            v-model="displayDone"
                            :label="`완료 보기`"
                            class="mr-5 mt-0"
                            style="float:right;"
                    ></v-checkbox>
                </v-col>
            </v-row>
            <v-simple-table class="mx-0">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="pl-0 text-center" query-key="dueDate" style="min-width:50px">납품일</th>
                        <th class="pl-0 text-center" query-key="title">작업명</th>
                        <th class="pl-0 text-center" query-key="orderStatus">진행</th>
                        <th class="pl-0 text-center" query-key="designStatus">시안</th>
                        <th class="pl-0 text-center" query-key="paymentStatus">결제</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="order in orders" :key="order.orderId" dense>
                        <td class="pl-0 font-weight-medium text-center">{{ order.shortDueDate }}</td>

                        <td class="pl-0 text-center">
                            {{ order.title }}
                            <HasDraftImageButton v-if="mobileFlag" :order-id="order.orderId" :filePath="order.filePath" :filePath2="order.filePath2" :filePath3="order.filePath3" :filePath4="order.filePath4" :filePath5="order.filePath5" :description="order.description" :refresh-orders="getOrders" :is-client="true"></HasDraftImageButton>
                        </td>
                        <td class="text-center">
                            <OrderStatusButton v-if="mobileFlag" :order-id="order.orderId" :disable="true"></OrderStatusButton>
                        </td>
                        <td class="text-center">
                            <DesignStatusButton v-if="mobileFlag" :order-id="order.orderId" :design-status="order.designStatus" :disable="true"></DesignStatusButton>
                        </td>
                        <td class="text-center">
                            <PaymentStatusButton v-if="mobileFlag" :order-id="order.orderId" :payment-status="order.paymentStatus" :disable="true"></PaymentStatusButton>
                        </td>
                    </tr>
                    <tr v-if="orders.length == 0">
                        <td colspan="5" class="no-data">
                            표시할 데이터가 없습니다.
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-main>

        <v-main class="d-none d-md-block">
            <v-row class="mb-0">
                <v-col cols="6">
                    <h2 class="my4"><v-icon>mdi-cards-playing-outline</v-icon>주문 내역</h2>
                </v-col>
                <v-col cols="6">
                    <v-btn icon outlined class="mr-3 mt-n1 d-none d-md-flex" style="float:right" @click="getOrders">
                        <v-icon>mdi-card-search</v-icon>
                    </v-btn>
                    <v-text-field
                            label="검색어를 입력하세요"
                            outlined
                            dense
                            clearable
                            v-model="orderSearchText"
                            @keydown.enter="getOrders"
                            class="mr-3 mt-n1 d-none d-sm-flex"
                            style="float:right;"
                    ></v-text-field>
                    <v-checkbox
                            v-model="displayDone"
                            :label="`완료 작업 보기`"
                            class="mr-5 mt-0"
                            style="float:right;"
                    ></v-checkbox>
                </v-col>
            </v-row>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-left" query-key="startDate">시작일</th>
                        <th class="pl-0 text-left" query-key="dueDate">납품일</th>
                        <th class="pl-0 text-left" query-key="category">분류</th>
                        <th class="pl-0 text-left" query-key="title">작업명</th>
                        <th class="pl-0 text-left" query-key="orderStatus">진행상태</th>
                        <th class="pl-0 text-left" query-key="designStatus">시안확인</th>
                        <th class="pl-0 text-left" query-key="paymentStatus">결제상태</th>
                        <th class="pl-0 text-left" query-key="taxStatus">세금계산</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="order in orders" :key="order.orderId" dense>
                        <td class="font-weight-medium text-start pl-4">{{ order.startDate }}</td>
                        <td class="font-weight-medium pl-0">{{ order.dueDate }}</td>
                        <td class="font-weight-medium pl-0">{{ order.category }}</td>
                        <td class="pl-0">
                            {{ order.title }}
                            <HasDraftImageButton v-if="pcFlag" :order-id="order.orderId" :filePath="order.filePath" :filePath2="order.filePath2" :filePath3="order.filePath3" :filePath4="order.filePath4" :filePath5="order.filePath5" :description="order.description" :refresh-orders="getOrders" :is-client="true"></HasDraftImageButton>
                        </td>
                        <td>
                            <OrderStatusButton v-if="pcFlag" :order-id="order.orderId" :disable="true"></OrderStatusButton>
                        </td>
                        <td>
                            <DesignStatusButton v-if="pcFlag" :order-id="order.orderId" :design-status="order.designStatus" :disable="true"></DesignStatusButton>
                        </td>
                        <td>
                            <PaymentStatusButton v-if="pcFlag" :order-id="order.orderId" :payment-status="order.paymentStatus" :disable="true"></PaymentStatusButton>
                        </td>
                        <td>
                            <TaxStatusButton v-if="pcFlag" :order-id="order.orderId" :tax-status="order.taxStatus" :disable="true"></TaxStatusButton>
                        </td>
                    </tr>
                    <tr v-if="orders.length == 0">
                        <td colspan="8" class="no-data">
                            표시할 데이터가 없습니다.
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-main>
    </div>
</template>

<script>
import OrderStatusButton from "@/components/order/button/OrderStatusButton";
import DesignStatusButton from "@/components/order/button/DesignStatusButton";
import PaymentStatusButton from "@/components/order/button/PaymentStatusButton";
import TaxStatusButton from "@/components/order/button/TaxStatusButton";
import HasDraftImageButton from "@/components/order/button/HasDraftImageButton";
import axios from "axios";

export default {
    name: 'OrderRows',
    props: {
      load: {}
    },
    components: {
        OrderStatusButton,
        DesignStatusButton,
        PaymentStatusButton,
        TaxStatusButton,
        HasDraftImageButton,
    },
    data () {
        return {
            orderSearchText: this.searchText,
            orders: [],
            imageDialog: false,
            clientName: null,
            displayDone: true,
            queryOptions: {
                prevKey: 'orders.id',
                queryKey: 'orders.id',
                queryOrder: 'desc',
                queryText: null,
                displayDone: true,
                clientPhone: null
            },
            mobileFlag: false,
            pcFlag: false
        }
    },
    watch: {
        orderSearchText: async function(newText) {
            this.queryOptions.queryText = newText

            if(newText == ''){
                await this.getOrders()
            }
        },
        displayDone: async function(value) {
            this.queryOptions.displayDone = value
            await this.getOrders()
        }
    },
    methods: {
        async getOrders() {

            if(this.load == false){
                return false
            }

            const clientInfo = this.$store.getters.getClientInfo

            if(!clientInfo || !clientInfo.clientPhone){
                alert('고객 인증정보가 존재하지 않습니다.')
                if(this.$route.params.clientCode){
                    await this.$router.push('/client/login/' + this.$route.params.clientCode)
                }
                return false
            }

            this.queryOptions.clientPhone = clientInfo.clientPhone

            return axios({
                method: 'POST',
                url: this.$store.getters.getApiUrl + '/api/v1/client/getClientOrders/' + this.$route.params.clientCode,
                data: this.queryOptions,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.status == '0000'){

                    let tmpOrders = response.data.data
                    const count = tmpOrders.length

                  console.log(tmpOrders)

                    for(let i = 0; i < count; i++){
                        tmpOrders[i].startDate = this.$day(tmpOrders[i].startDate).format('YYYY/MM/DD')
                        tmpOrders[i].dueDate = this.$day(tmpOrders[i].dueDate).format('YYYY/MM/DD')
                        tmpOrders[i].shortDueDate = this.$day(tmpOrders[i].dueDate).format('MM/DD')
                    }

                    this.orders = tmpOrders
                    this.$forceUpdate()

                }else{

                    this.orders = []

                }

            })
            .catch(() => {

                //로그인 실패 시
                alert('주문정보 조회에 실패했습니다.')
                this.$rollbar.error('고객 주문내역 조회 실패', this.$el)

            })

        }
    },
    mounted: async function() {
        await this.getOrders()
        this.clientName = this.$store.getters.getClientInfo.clientName

        switch(this.$vuetify.breakpoint.name) {
            case 'xl':
            case 'lg':
            case 'md':
                this.mobileFlag = false
                this.pcFlag = true
                break
            case 'sm':
            case 'xs':
                this.mobileFlag = true
                this.pcFlag = false
                break
        }
    }
}
</script>

<style scoped>
    .no-data { text-align: center; background-color: aliceblue; }
    table, tr, td { padding: 0em }
    tr, td {
        padding: 2px !important;
    }
</style>